import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";
import "./broadcastPreview.scss";
import { buildBroadcastMessagePreview } from "../../utils/winnerWorkflow";

const PreviewBroadcastModal = ({
  show,
  toggle,
  confirm,
  model,
  isLoading = false,
  error,
}) => {
  const promo = model?.promo;
  const canContinue = !isLoading && !error && model && model.blockers.length === 0;
  const sample = model?.messageSample;
  const voucherImageUrl = sample?.voucherImage
    ? (/^https?:\/\//i.test(sample.voucherImage)
      ? sample.voucherImage
      : `${process.env.REACT_APP_API_URL}${sample.voucherImage}`)
    : "";
  const period = promo?.start_date && promo?.end_date
    ? `${moment(promo.start_date).format("DD MMM YYYY")} - ${moment(promo.end_date).format("DD MMM YYYY")}`
    : "-";

  return (
    <Modal size="lg" isOpen={show} toggle={isLoading ? undefined : toggle} backdrop={isLoading ? "static" : true} keyboard={!isLoading}>
      <ModalHeader toggle={isLoading ? undefined : toggle}>Preview Broadcast Pemenang</ModalHeader>
      <ModalBody className="broadcast-preview">
        {isLoading && <div className="broadcast-preview-loading"><span className="spinner-border" /> Menyiapkan preview...</div>}
        {!isLoading && error && <div className="broadcast-preview-alert is-blocker" role="alert">{error}</div>}
        {!isLoading && model && (
          <>
            <div className="broadcast-preview-summary">
              <div><span>Promo</span><strong>{promo?.name || "-"}</strong></div>
              <div><span>Periode</span><strong>{period}</strong></div>
              <div><span>Penerima</span><strong>{model.eligibleRecipients.length}</strong></div>
              <div><span>Diskualifikasi</span><strong>{model.excludedDisqualifiedCount}</strong></div>
            </div>

            {model.blockers.map((message) => <div key={message} className="broadcast-preview-alert is-blocker">{message}</div>)}
            {model.warnings.map((message) => <div key={message} className="broadcast-preview-alert is-warning">{message}</div>)}

            <section>
              <h6>Status kelengkapan</h6>
              <div className="broadcast-preview-completeness">
                {model.completeness.map((item) => (
                  <div key={item.key} className={item.isComplete ? "is-complete" : item.warningOnly ? "is-warning" : "is-incomplete"}>
                    <span>{item.isComplete ? "✓" : "!"}</span>
                    <div>
                      <strong>{item.label}</strong>
                      <small>{item.message}</small>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h6>Ringkasan per toko</h6>
              <div className="broadcast-preview-outlets">
                {model.outletSummary.map((outlet) => <span key={outlet.name}>{outlet.name}<strong>{outlet.count}</strong></span>)}
                {!model.outletSummary.length && <span>Tidak ada data toko</span>}
              </div>
            </section>

            <section>
              <h6>Contoh pesan broadcast</h6>
              <div className="broadcast-message-card">
                {voucherImageUrl
                  ? <img src={voucherImageUrl} alt={`Voucher ${sample.storeName}`} />
                  : <div className="broadcast-message-placeholder">Foto voucher belum tersedia</div>}
                <div>
                  <p style={{ whiteSpace: "pre-line" }}>{buildBroadcastMessagePreview(sample, promo)}</p>
                  {sample && <small>Dikirim ke contoh penerima: {sample.fullName} ({sample.phoneNumber || "nomor belum tersedia"})</small>}
                </div>
              </div>
            </section>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <button type="button" className="button-batal" onClick={toggle} disabled={isLoading}>Batal</button>
        <button type="button" className="button-simpan" onClick={confirm} disabled={!canContinue}>Lanjutkan</button>
      </ModalFooter>
    </Modal>
  );
};

export default PreviewBroadcastModal;
